<template>
  <button class="ot-button" @click="buttonClicked">
    <slot></slot>
  </button>
</template>
<script setup>
import { inject } from "vue";

const audioManager = inject("audioManager");

defineProps({
  text: {
    type: String,
    default: "OK",
  },
});

const emit = defineEmits(["click"]);
const buttonClicked = (event) => {
  event.stopPropagation();
  audioManager.play("click").then(() => {
    emit("click", event);
  });
};
</script>
<style scoped lang="scss">
.ot-button {
  font-family: var(--pixel-cowboy);
  font-size: clamp(24px, 2rem, 30px);
  line-height: 1rem;
  background: url("../assets/images/button-border-left.png") no-repeat left
      center border-box,
    url("../assets/images/button-border-right.png") no-repeat right center
      border-box,
    url("../assets/images/button-border-center.png") no-repeat center border-box,
    linear-gradient(to bottom, #fcf688, #fcf688) padding-box;
  background-size: auto 100%, auto 100%, calc(100% - 80px) 100%, 100% 100%;
  border: 15px solid transparent;
  outline: none;
  cursor: pointer;
  padding: 10px 30px;
  min-width: 210px;
  min-height: 80px;
  font-weight: 600;
  color: #000;
  white-space: nowrap;

  &:active {
    transform: translate3d(2px, 2px, 0);
    filter: brightness(0.9);
  }
  @media (max-width: 768px) {
    font-size: clamp(18px, 1.5rem, 24px);
    padding: 5px 20px;
    min-width: 150px;
    min-height: 60px;
    border: 12px solid transparent;
    background-size: auto 100%, auto 100%, calc(100% - 40px) 100%, 100% 100%;
  }
}
</style>
